/**
 * Extract person/user ID from API response
 */
export function extractPersonId(resp: any): string | null {
  if (!resp) return null;

  // Try nested profile object first (ProfileEditDto)
  const profile = resp.profile ?? resp.Profile;
  if (profile) {
    const id = profile.id ?? profile.Id ?? profile.personId ?? profile.PersonId;
    if (id) return String(id);
  }

  // Try direct properties (flat structure)
  const directId = resp.id ?? resp.Id ?? resp.personId ?? resp.PersonId;
  if (directId) return String(directId);

  return null;
}

/**
 * Extract personId directly from a JWT access token payload, when the API
 * includes a custom `personId` (or `pid`) claim. Returns null if absent.
 */
/**
 * Extract the AspNetUsers GUID from a JWT access token payload (nameid /
 * sub / the full ClaimTypes.NameIdentifier URI). Returns null if absent.
 * Needed because session.user.id is the EMAIL, not the auth GUID.
 */
export function extractUserIdFromToken(token?: string): string | null {
  if (!token || typeof token !== 'string') return null;
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = typeof atob === 'function' ? atob(b64) : Buffer.from(b64, 'base64').toString('utf8');
    const payload = JSON.parse(json || '{}');
    const id = payload?.nameid ?? payload?.sub
      ?? payload?.['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'];
    if (id === undefined || id === null) return null;
    const s = String(id).trim();
    return s.length ? s : null;
  } catch { return null; }
}

export function extractPersonIdFromToken(token?: string): string | null {
  if (!token || typeof token !== 'string') return null;
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = typeof atob === 'function' ? atob(b64) : Buffer.from(b64, 'base64').toString('utf8');
    const payload = JSON.parse(json || '{}');
    const pid = payload?.personId ?? payload?.pid;
    if (pid === undefined || pid === null) return null;
    const s = String(pid).trim();
    return s.length ? s : null;
  } catch { return null; }
}
